module.exports = __webpack_public_path__ + "static/TT1446_TW-MKM01_r1-header-ed5fc259546ed4af2aab7404ccdecfc9.png";